import { PhotoAndTextCardFieldsFragment } from '../../../@types/generated';
import { Paragraph } from 'components/src/typography';

type Props = {
  data: PhotoAndTextCardFieldsFragment;
};

const DisclaimerSection = ({ data }: Props) => {
  return (
    data.disclaimer && (
      <Paragraph variant="small" classes="mt-16 pl-32 pr-32 text-center md:col-span-8 md:col-start-2 md:mt-32 md:p-0">
        {data.disclaimer}
      </Paragraph>
    )
  );
};
export default DisclaimerSection;
